/**
 * 앱 설치 유도 모달을 띄우는 딥링크인지. (`ably://app-download`)
 *
 * 이동 대상이 아니라 "모달을 띄워라" 라는 신호라서 `useOpenDeeplink` 가 라우팅 판별보다
 * 먼저 걸러낸다. **웹 전용** — 앱에서는 유도할 게 없으므로 아무 동작도 하지 않는다
 * (네이티브 bridge 로도 넘기지 않는다).
 *
 * 언더스코어 표기(`app_download`)도 같이 받는다 — 딥링크는 서버/콘텐츠가 만들어 보내므로
 * 표기가 섞여 들어와도 동작하게 둔다.
 */
export const isAppDownloadDeeplink = (link: string): boolean =>
  /^ably:\/\/app[-_]download(\/|\?|$)/.test(link);
